import { Bot } from "lucide-react";
import { cn } from "@/components/ui/cn";

/**
 * The assistant's nav mark: the robot glyph with a small "AI" badge riding its
 * shoulder — for the one link in the header that is a who, not a where. Drawn
 * identically in the header, the phone drawer and the editor preview, so the
 * special link looks the same wherever the nav is rendered.
 *
 * Decorative: the link's label (the persona's name) is the accessible name.
 * "AI" is a glyph, not copy — it reads the same in every language — so it is
 * coded rather than a Dict row. Colours are the header's own: the gold accent
 * on the badge with the teal it sits on in the drawer, legible on the frosted
 * and the overlay header alike.
 */
export function AssistantMark({ className }: { className?: string }) {
  return (
    <span className={cn("relative inline-flex shrink-0", className)} aria-hidden>
      <Bot className="-mt-0.5 size-6" strokeWidth={1.75} />
      <span className="bg-gold text-teal absolute -top-1.5 -left-2 flex size-4 items-center justify-center rounded-full text-[8px] leading-none font-bold">
        AI
      </span>
    </span>
  );
}
